var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispositivosVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M15 1.2c1.56327596.02177096 3.06170434.62827769 4.2 1.7l.8-.8C18.68337733.75622761 16.88128134-.00102051 15-.00102051c-1.88128134 0-3.68337733.75724812-5 2.10102051l.8.8c1.13829566-1.07172231 2.63672404-1.67822904 4.2-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M11.7 3.7l.8.8c1.4-1.33333333 3.6-1.33333333 5 0l.8-.8c-.86468049-.89481275-2.05566797-1.40012543-3.3-1.40012543-1.24433203 0-2.43531951.50531268-3.3 1.40012543z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M15.55599976 12h2.22201538c1.16345215-.05456543 2.15423584.83721924 2.22198486 2v4c-.06774902 1.16278076-1.05853271 2.05456543-2.22198486 2H2.22198486C1.05853271 20.05456543.06774902 19.16278076 0 18v-4c.06774902-1.16278076 1.05853271-2.05456543 2.22198486-2h11.11102295V8h2.22299195v4zm-13.3340149 6h15.55599976v-4H2.22198486v4z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 3.375,
    y: 14.625,
    fill: "rgb(54,216,150)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 7.313,
    y: 14.625,
    fill: "rgb(54,216,150)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 11.25,
    y: 14.625,
    fill: "rgb(54,216,150)",
    rx: 0,
    ry: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispositivosVerde);
export default __webpack_public_path__ + "static/media/dispositivos_verde.7d7ef99ac5771f078b6dd6d84ba97126.svg";
export { ForwardRef as ReactComponent };